/*
 * auction-status-panel.js
 *
 * 目的: snippets/auction-status-panel.liquid の preparing フォールバックを、
 *       Tipo widget が可視描画された時点で hidden 化する。
 *
 * 仕様（rev2.3 / 2026-06-07 22:30 JST / 真因「CSS display:flex の [hidden] override」修正）:
 *   - 対象: .auction-status-panel--preparing のみ（Unsold は対象外）
 *   - 判定: Tipo widget の代表 class（複数）のいずれかが
 *           preparing パネルの近傍スコープ内に存在し、offsetParent !== null（=可視）
 *   - 主監視: MutationObserver（scope 内 childList/subtree）即時検知
 *   - 補助: 200ms 間隔 setInterval（Observer 補助 + 可視状態変化追従）
 *   - タイムアウト: 30 秒に拡張（Tipo widget の遅延描画対応）
 *   - 早期 return: preparing パネルがなければ何もしない
 *   - レイアウト全体で1回だけ読み込まれる前提（layout/theme.liquid 末尾）
 *   - 多重実行ガード: window.__auctionStatusPanelLoaded フラグ
 *
 * rev2.1 → rev2.2 変更点:
 *   - 10 秒 → 30 秒（Tipo widget の遅延描画で実機 NG が観測されたため）
 *   - setInterval 単体 → MutationObserver 主 + setInterval 補助のハイブリッド
 *
 * Tipo widget DOM 接頭辞は `tpa-` （実機 LIVE 観測 2026-06-07）。
 * 過去版が依拠していた `.tpa-product-widget` は実 DOM に存在しない。
 *
 * 近傍スコープ（preparing.closest('main')）化の理由:
 *   コレクションページ内の card-product 等で tipo-auction-collection
 *   が同時 render される構成のとき、別商品の Tipo DOM を誤検知して
 *   preparing を消してしまう事故を回避するため。
 *
 * Tipo widget が描画されない真の障害時は preparing 残置（fallback 設計どおり）。
 */
(function () {
  'use strict';

  // 多重実行ガード（snippet 側で誤って同 asset を render された場合の二重 setInterval 防止）
  if (window.__auctionStatusPanelLoaded) return;
  window.__auctionStatusPanelLoaded = true;

  var PREPARING_SELECTOR = '.auction-status-panel--preparing';
  // Tipo widget の代表 class を列挙（pending/live/closed/won/lost いずれかで必ず可視に出る）
  var TIPO_SELECTORS = '.tpa-action, .tpa-button, .tpa-badge, .tpa-heading-messenger, .tpa-live_phone_label, .tpa-modal-container, .tpa-bidding__Spinner, .tpa-product-widget, .tpa-product-widget__status';
  var POLL_INTERVAL_MS = 200;
  var TIMEOUT_MS = 30000;

  function findVisibleTipoWidget(scope) {
    var root = scope || document.body;
    var widgets = root.querySelectorAll(TIPO_SELECTORS);
    for (var i = 0; i < widgets.length; i++) {
      if (widgets[i].offsetParent !== null) return widgets[i];
    }
    return null;
  }

  function hidePreparingPanels() {
    var panels = document.querySelectorAll(PREPARING_SELECTOR);
    for (var i = 0; i < panels.length; i++) {
      panels[i].setAttribute('hidden', '');
      // CSS .auction-status-panel { display: flex } が [hidden] を override するため、
      // インラインスタイル（specificity 1,0,0,0）で強制的に display:none を当てる。
      panels[i].style.display = 'none';
    }
  }

  function init() {
    var preparing = document.querySelector(PREPARING_SELECTOR);
    if (!preparing) return;

    // 近傍スコープ: preparing の最も近い <main>。なければ <body> へフォールバック
    var scope = preparing.closest('main') || document.body;

    if (findVisibleTipoWidget(scope)) {
      hidePreparingPanels();
      return;
    }

    var done = false;
    var observer = null;
    var intervalId = null;
    var timeoutId = null;

    function tryHide() {
      if (done) return;
      if (findVisibleTipoWidget(scope)) {
        hidePreparingPanels();
        done = true;
        if (observer) observer.disconnect();
        if (intervalId) clearInterval(intervalId);
        if (timeoutId) clearTimeout(timeoutId);
      }
    }

    // 主監視：MutationObserver で DOM 変更検知
    if (typeof MutationObserver === 'function') {
      observer = new MutationObserver(tryHide);
      observer.observe(scope, { childList: true, subtree: true });
    }

    // 補助：setInterval（Observer は class 変更/可視状態のみ変化したケースを拾えないため）
    intervalId = setInterval(tryHide, POLL_INTERVAL_MS);

    // タイムアウト：30 秒で全停止
    timeoutId = setTimeout(function () {
      done = true;
      if (observer) observer.disconnect();
      if (intervalId) clearInterval(intervalId);
    }, TIMEOUT_MS);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
